import { render } from "./AIForgeName.vue?vue&type=template&id=997172e2&ts=true"
import script from "./AIForgeName.vue?vue&type=script&lang=ts"
export * from "./AIForgeName.vue?vue&type=script&lang=ts"

import "./AIForgeName.vue?vue&type=style&index=0&id=997172e2&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__